var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdealconversationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9C14.5 9.53043 14.2893 10.0391 13.9142 10.4142C13.5391 10.7893 13.0304 11 12.5 11H6.5L2.5 15V4C2.5 2.9 3.4 2 4.5 2H12.5C13.0304 2 13.5391 2.21071 13.9142 2.58579C14.2893 2.96086 14.5 3.46957 14.5 4V9Z",
    stroke: "#0773EA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9H20.5C21.0304 9 21.5391 9.21071 21.9142 9.58579C22.2893 9.96086 22.5 10.4696 22.5 11V22L18.5 18H12.5C11.9696 18 11.4609 17.7893 11.0858 17.4142C10.7107 17.0391 10.5 16.5304 10.5 16V15",
    stroke: "#0773EA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdealconversationicon);
export default __webpack_public_path__ + "static/media/idealconversationicon.263d868d7ee5c1fc3df9fee1c6ad7410.svg";
export { ForwardRef as ReactComponent };